export default __webpack_public_path__ + "static/media/hot_cup_loading.188ac267.gif";